/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Apis_Tools_HintInputs */



/**
* | output |
* | --- |
* | "Which of the assistant's tools may be used through this space. By default all of them are." |
*
* @param {Integrations_Apis_Tools_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_apis_tools_hint = /** @type {((inputs?: Integrations_Apis_Tools_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Apis_Tools_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Welche Werkzeuge des Assistenten über diesen Space verwendet werden dürfen. Standardmäßig sind es alle.")
	return /** @type {LocalizedString} */ ("Which of the assistant's tools may be used through this space. By default all of them are.")
});